import React, { useEffect } from "react";
import { BaseButton } from "../base";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Modal from "../base/modal";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "../base/typography";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  AccordionSummary,
  AccordionDetails,
  Accordion
} from "../base/accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EInfoToolTip from "../_elements/eInfo-tooltip";
import { eColors } from "../../global_vars";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Popover from "@mui/material/Popover";
import KPIList from "../kpi-list";
import CircularProgress from "@mui/material/CircularProgress";
import { FormattedMessage } from "react-intl";
import EformBuilder from "../_eform/eform-builder";
import PlentyGuide from "../connectors-guide/plenty-guide";
import DreamRobotGuide from "../connectors-guide/dream-robot-guide";
import EbayGuide from "../connectors-guide/ebay-guide";
import JtlGuide from "../connectors-guide/jtl-guide";
import TricomaGuide from "../connectors-guide/tricoma-guide";
import APIContext from "../../services/api/api";
import { EcAuthContext } from "@eclear-ag/ec-common-ui";
import BillbeeGuide from "../connectors-guide/billbee-guide";
import UserContext from "../../services/user/user";
import EbayGuide2 from "../connectors-guide/ebay-guide2";

const modalStyle = {
  position: "absolute",
  top: "25%",
  left: "50%",
  transform: "translate(-50%, -25%)",
  width: "76%",
  bgcolor: "infoLight.main",
  p: "32px 40px"
};

const connenctorsList = [
  // { name: "afterpay", logo: "./logos/KPIs/KPI-Logos-1.png" },
  // { name: "amazon", logo: "./logos/KPIs/KPI-Logos.png" },
  {
    id: "",
    title: "",
    name: "BILL_BEE",
    logo: "./logos/KPIs/KPI-Logos-22.png",
    formData: [
      {
        name: "account",
        label: "billbee.account",
        type: "text",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      },
      {
        name: "password",
        label: "password",
        type: "password",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      }
    ],
    guide: <BillbeeGuide />
  },
  {
    id: "",
    title: "",
    name: "EBAY",
    logo: "./logos/KPIs/KPI-Logos-6.png",
    formData: [
      {
        name: "token",
        label: "token",
        type: "text",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      }
    ],
    guide: <EbayGuide />
  },
  {
    id: "",
    title: "",
    name: "DREAM_ROBOT",
    logo: "./logos/KPIs/KPI-Logos-5.png",
    formData: [
      {
        name: "refresh_token",
        label: "refreshToken",
        type: "text",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      }
    ],
    guide: <DreamRobotGuide />
  },
  {
    id: "",
    title: "",
    name: "JTL",
    logo: "./logos/KPIs/KPI-Logos-8.png",
    formData: [
      {
        name: "serverName",
        label: "serverName",
        type: "text",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      },
      {
        name: "databaseName",
        label: "databaseName",
        type: "text",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      },
      {
        name: "email",
        label: "User",
        type: "text",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      },
      {
        name: "password",
        label: "password",
        type: "text",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      }
    ],
    guide: <JtlGuide />
  },
  {
    id: "",
    title: "",
    name: "TRICOMA",
    logo: "./logos/KPIs/KPI-Logos-20.png",
    formData: [
      {
        name: "shopUrl",
        label: "shopUrl",
        type: "text",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      },
      {
        name: "token",
        label: "token",
        type: "text",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      }
    ],
    guide: <TricomaGuide />
  },
  {
    id: "",
    title: "",
    name: "PLENTY_MARKET",
    logo: "./logos/KPIs/KPI-Logos-15.png",
    formData: [
      {
        name: "shopUrl",
        label: "shopUrl",
        type: "text",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      },
      {
        name: "webIDs",
        label: "webIDs",
        type: "chipsInput",
        size: "widget-col-12",
        required: false,
        tooltip: true,
        tooltipMessage: "webIDs.tooltip",
        value: "",
        disabled: false
      },
      {
        name: "account",
        label: "plentymarketRestApiAccount",
        type: "text",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      },
      {
        name: "password",
        label: "plentymarketRestApiPassword",
        type: "password",
        size: "widget-col-12",
        required: true,
        value: "",
        disabled: false
      },
      {
        name: "isThirdPart",
        label: "plentymarketRestApiDocuments",
        type: "checkbox",
        size: "widget-col-12",
        required: true,
        value: false,
        disabled: false
      }
    ],
    guide: <PlentyGuide />
  }
];

export default function Connectors() {
  // context
  const { getData } = React.useContext(APIContext);
  const { user } = React.useContext(EcAuthContext);
  const { setHasConnectors } = React.useContext(UserContext);

  // states
  const [connectors, setConnectors] = React.useState([]);
  const [activeConnector, setActiveConnector] = React.useState(
    connectors[0] || ""
  );
  const [openModal, setOpenModal] = React.useState(false);
  const [connectorData, setConnectorData] = React.useState([]);
  const [accordionExpand, setAccordionExpand] = React.useState(false);
  const [ebayAccordionExpand, setEbayAccordionExpand] = React.useState(false);
  // config is the list of connectors from backend
  const [config, setConfig] = React.useState();

  // helper methods
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const handleAccordionExpand = () => setAccordionExpand(!accordionExpand);

  const addCreds = () => {
    setConnectorData([...connectorData, activeConnector]);
  };

  const initConnectors = async (isFirstMount) => {
    // isFirstMount = true;
    const res = await getData(`configuration`, {
      userId: user.accessToken.payload.sub
    });

    if (res) {
      setConfig(res);
      let userConnectors = res.map((c) => c.configType);
      userConnectors = [...new Set(userConnectors)];
      let connectorsList = isFirstMount ? [] : connectors;
      // let connectorsList = connectors;
      isFirstMount &&
        userConnectors.forEach((c) => {
          return connectorsList.push(
            connenctorsList.find((cl) => cl.name === c)
          );
        });
      setConnectors(connectorsList);
    } else {
      setConfig([]);
    }
  };

  // hooks
  // Get list of connected connectors from Backend
  useEffect(() => {
    initConnectors(true);
  }, []);

  // Get connector Data from Backend everytime active connector chages
  useEffect(() => {
    if (activeConnector && config) {
      // get connector KPIs form data from config
      const connectorDataList = config.filter(
        (c) => c.configType === activeConnector.name
      );
      let connectorWithData = [];
      connectorDataList.forEach((c) => {
        let clone = { ...activeConnector };
        clone.id = c.id;
        clone.title = c.name;
        clone.formData = activeConnector.formData.map((f) => {
          return { ...f };
        });
        // update formData
        clone.formData.forEach((el) => {
          el.value = c.data[el.name];
        });

        connectorWithData.push(clone);
      });

      setConnectorData(connectorWithData);
    } else {
      if (activeConnector) {
        setConnectorData([activeConnector]);
      }
    }
  }, [activeConnector, connectors, config]);

  useEffect(() => {
    if (!activeConnector && connectors.length > 0) {
      setActiveConnector(connectors[0]);
    }
  }, [connectors]);

  useEffect(() => {
    setConnectorData(connectorData);
  }, [connectorData]);

  // const [arrSet, setArrSet] = useState(new Set());
  // useEffect(() => {
  //   console.log("Connectors: ", connectors);
  //   console.log("Connector Data: ", connectorData);
  //   // setArr([
  //   //   ...new Set(
  //   //     connectorData.map((item) => {
  //   //       return item.id;
  //   //     })
  //   //   ),
  //   // ]);

  //   // if (arrSet.indexOf(connectorData) === -1) {
  //   setArrSet([...arrSet, ...connectorData]);
  //   // }

  //   connectors.length > 0 ? setHasConnectors(true) : setHasConnectors(false);
  // }, [connectorData, connectors]);

  // useEffect(() => {
  //   // const filtered = arrSet.filter(
  //   //   (itemInArray) => itemInArray.id === itemInArray.id
  //   // );
  //   // console.log(filtered);
  //   // console.log(arrSet);
  // }, [arrSet]);

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(12, 1fr)",
          gridGap: "20px"
        }}
      >
        {/* left sidebar add connector btn & connectors kpi list */}
        <Box className="widget-col-2">
          <BaseButton
            variant="filled"
            onClick={handleOpenModal}
            startIcon={
              <AddCircleOutlineIcon
                style={{ color: "var(--text-primary-inverse) !important" }}
              />
            }
            sx={{
              border: "2px solid #e8ebef",
              borderRadius: "6px",
              width: "100%"
            }}
          >
            <FormattedMessage id="addConnector" />
          </BaseButton>
          <Box sx={{ mt: "18px" }}>
            <KPIList
              title="connectors"
              stores={connectors}
              setSelectedStore={setActiveConnector}
            />
          </Box>
        </Box>
        {/* Forms */}
        <Box className="widget-col-10">
          {activeConnector.formData &&
            connectorData.length > 0 &&
            connectorData.map((con, index) => {
              return (
                <KPIForm
                  formElements={con.formData}
                  connectorIndex={index}
                  setConnectorData={setConnectorData}
                  connectorData={connectorData}
                  key={con.name + "-" + index}
                  initConnectors={initConnectors}
                />
              );
            })}

          {/* add credentials btn */}
          {activeConnector.formData && (
            <React.Fragment>
              <BaseButton
                variant="filled"
                startIcon={<AddCircleOutlineIcon />}
                sx={{
                  border: "2px solid #e8ebef",
                  borderRadius: "6px",
                  width: "100%",
                  maxWidth: "180px"
                }}
                onClick={addCreds}
              >
                <FormattedMessage id="addCredentials" />
              </BaseButton>

              <Accordion
                expanded={accordionExpand}
                onChange={handleAccordionExpand}
                sx={{
                  mt: "30px",
                  borderRadius: "8px"
                }}
                elevation={0}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon color="primary" />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography sx={{ fontWeight: 500 }}>
                    <FormattedMessage id="kpi.guide" />
                  </Typography>
                </AccordionSummary>
                <Divider />
                <AccordionDetails>{activeConnector.guide}</AccordionDetails>
              </Accordion>

              {activeConnector.name === "EBAY" && (
                <EbayGuide2
                  expanded={ebayAccordionExpand}
                  onChange={() => {
                    setEbayAccordionExpand(!ebayAccordionExpand);
                  }}
                  sx={{
                    mt: "30px",
                    borderRadius: "8px"
                  }}
                  elevation={0}
                />
              )}
            </React.Fragment>
          )}
        </Box>
      </Box>

      {/* CONNECTORS MODAL */}
      <Modal
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Box sx={{ textAlign: "right" }}>
            <IconButton aria-label="close modal" onClick={handleCloseModal}>
              <CloseIcon
                alt="close icon"
                style={{ color: "var(text-primary)" }}
              />
            </IconButton>
          </Box>
          <ModalConnectorSelect
            updateConnectors={setConnectors}
            handleCloseModal={handleCloseModal}
            initVal={connectors}
          />
        </Box>
      </Modal>
    </React.Fragment>
  );
}

function ModalConnectorSelect({ updateConnectors, handleCloseModal, initVal }) {
  const [connectors, setConnectors] = React.useState(initVal);
  const handleConnectors = (event, newConnector) => {
    setConnectors(newConnector);
  };

  const addConnectors = () => {
    updateConnectors(connectors);
    handleCloseModal();
  };

  const cancel = () => {
    setConnectors(initVal);
    handleCloseModal();
  };

  return (
    <React.Fragment>
      <Box sx={{ p: "0 80px" }}>
        <Typography
          variant="h3"
          sx={{
            fontSize: "20px",
            fontWeight: 500,
            m: "0 0 35px 0",
            pb: "13px",
            borderBottom: "2px solid var(--border)"
          }}
        >
          <FormattedMessage id="financialConnectors" />
          <EInfoToolTip
            msg={
              <ul className="tooltip-list">
                <li>
                  <strong style={{ color: eColors[0] }}>
                    <FormattedMessage id="financialConnectors" />
                  </strong>{" "}
                  <FormattedMessage
                    id="financialConnectors.popup.text"
                    values={{
                      b: (...chunks) => {
                        return <span>{`"`}</span>;
                      }
                    }}
                  />
                </li>
              </ul>
            }
          />
        </Typography>
        <ToggleButtonGroup
          value={connectors}
          onChange={handleConnectors}
          aria-label="connectors"
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gridGap: "24px",
            ".Mui-selected": {
              opacity: "1"
            },
            ".MuiToggleButton-root": {
              border: "2px solid #e8ebef !important",
              m: "0 !important",
              borderRadius: "6px !important",
              "&:hover": {
                opacity: "0.8"
              }
            }
          }}
        >
          {connenctorsList.map((connector) => (
            <ToggleButton
              value={connector}
              aria-label={connector.name}
              key={connector.name}
              sx={{
                padding: 0,
                maxWidth: "100%",
                opacity: "0.4"
              }}
            >
              <img
                src={connector.logo}
                alt={connector.name}
                className="img-fluid"
                style={{ borderRadius: "6px" }}
              />
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: "50px"
          }}
        >
          <BaseButton
            variant="text"
            onClick={cancel}
            sx={{ opacity: "0.4" }}
          >
            <FormattedMessage id="cancel" />
          </BaseButton>
          <BaseButton
            variant="filled"
            onClick={addConnectors}
            disabled={connectors.length < 1}
          >
            <FormattedMessage id="financialConnectors.add" /> &nbsp;
            <span style={{ color: "#97a1b1" }}>({connectors.length})</span>
          </BaseButton>
        </Box>
      </Box>
    </React.Fragment>
  );
}

// connectorData is a list of connector KPIs info
function KPIForm({
  formElements,
  connectorIndex,
  setConnectorData,
  connectorData,
  initConnectors
}) {
  const { updateData, postData, deleteData } = React.useContext(APIContext);
  const {
    userData,
    setIsSaveSuccess,
    setIsSnackBarVisible,
    setHasConnectors,
    getConnectors
  } = React.useContext(UserContext);
  const { user } = React.useContext(EcAuthContext);

  const childRef = React.useRef();
  const kpiNameRef = React.useRef();
  const [formElementsClone, setFormElementsClone] = React.useState(
    formElements.map((child) => ({ ...child }))
  );
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [modalType, setModalType] = React.useState();
  const [kpiConnectorData, setKpiConnectorData] = React.useState([]);

  const [isLoading, setIsLoading] = React.useState(false);
  const [isDeleting, setIsDeleting] = React.useState(false);

  useEffect(() => {
    setKpiConnectorData(connectorData);
  }, [connectorData]);

  const handleOpenModal = (modalAction) => {
    setOpenModal(true);
    setModalType(modalAction);
  };
  const handleCloseModal = () => setOpenModal(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? `connector-${connectorIndex}` : undefined;

  const removeKpi = async (e) => {
    const kpi = kpiConnectorData[connectorIndex];
    try {
      setIsDeleting(true);
      const clone = kpiConnectorData.slice();
      clone.splice(connectorIndex, 1);
      if (kpiConnectorData[connectorIndex].id !== "") {
        const res = await deleteData(`configuration/${kpi.id}`);
      }

      setConnectorData(clone);

      getConnectors();
      initConnectors();
      handleCloseModal();
      setIsDeleting(false);
    } catch (err) {
      console.error(err);
      handleCloseModal();
    }
  };

  const isFormDataIdentical = (reqObj_name, reqObj_data, kpi_formData) => {
    switch (reqObj_name) {
      case "TRICOMA":
        if (
          reqObj_data.shopUrl === kpi_formData[0].value &&
          reqObj_data.token === kpi_formData[1].value
        ) {
          return true;
        } else {
          return false;
        }
      case "EBAY":
        if (reqObj_data.token === kpi_formData[0].value) {
          return true;
        } else {
          return false;
        }
      case "BILL_BEE":
        if (
          reqObj_data.account === kpi_formData[0].value &&
          reqObj_data.password === kpi_formData[1].value
        ) {
          return true;
        } else {
          return false;
        }
      case "DREAM_ROBOT":
        if (reqObj_data.refresh_token === kpi_formData[0].value) {
          return true;
        } else {
          return false;
        }
      case "JTL":
        if (
          reqObj_data.serverName === kpi_formData[0].value &&
          reqObj_data.databaseName === kpi_formData[1].value &&
          reqObj_data.email === kpi_formData[2].value &&
          reqObj_data.password === kpi_formData[3].value
        ) {
          return true;
        } else {
          return false;
        }
      case "PLENTY_MARKET":
        if (
          reqObj_data.shopUrl === kpi_formData[0].value &&
          reqObj_data.account === kpi_formData[1].value &&
          reqObj_data.password === kpi_formData[2].value &&
          reqObj_data.isThirdPart === kpi_formData[3].value &&
          reqObj_data.webIDs === kpi_formData[4].value
        ) {
          return true;
        } else {
          return false;
        }
      default:
        return false;
    }
  };

  const handleSaveKpi = async () => {
    const kpi = connectorData[connectorIndex];

    // format request object
    const formObj = createFormObj(childRef.current.getFormData);

    const reqObj = {
      name:
        kpi.title ||
        `${connectorData[connectorIndex].name}-${connectorIndex + 1}`,
      storeId: userData.companyId,
      configType: kpi.name,
      data: formObj
    };

    // if there is an id then update the kpi else submit new kpi
    if (kpi.id) {
      try {
        if (
          !isFormDataIdentical(reqObj.configType, reqObj.data, kpi.formData)
        ) {
          setIsLoading(true);
          const res = await updateData(`configuration/${kpi.id}`, reqObj);
          setIsLoading(false);
          res === "success" ? setIsSaveSuccess(true) : setIsSaveSuccess(false);
          setIsSnackBarVisible(true);
          setHasConnectors(true);
          setFormElementsClone(childRef.current.getFormData);
        }
      } catch (err) {
        console.error("Error: ", err);
      }
    } else {
      try {
        setIsLoading(true);
        const res = await postData(`configuration`, reqObj, {
          userId: user.accessToken.payload.sub
        });
        setIsLoading(false);
        setIsSaveSuccess(true);
        setIsSnackBarVisible(true);
        setHasConnectors(true);
        if (connectorData[connectorIndex].id === "") {
          initConnectors();
        }
      } catch (err) {
        console.error("Error: ", err);
        setIsLoading(false);
        setIsSaveSuccess(false);
        setIsSnackBarVisible(true);
      }
    }
  };

  const handleUpdateName = async () => {
    const kpi = connectorData[connectorIndex];

    // format request object
    const formObj = createFormObj(childRef.current.getFormData);

    const reqObj = {
      name: kpiNameRef.current.getElementValue(
        `${connectorData[connectorIndex].name}-${connectorIndex}`
      ),
      storeId: userData.companyId,
      configType: kpi.name,
      data: formObj
    };
    // if there is an id then update the kpi else submit new kpi
    if (kpi.id) {
      try {
        const res = await updateData(`configuration/${kpi.id}`, reqObj);
        const clone = connectorData.slice();
        clone[connectorIndex].title = kpiNameRef.current.getElementValue(
          `${connectorData[connectorIndex].name}-${connectorIndex}`
        );
        setConnectorData(clone);
        handleCloseModal();
      } catch (err) {
        console.error(err);
      }
    } else {
      const clone = connectorData.slice();
      clone[connectorIndex].title = kpiNameRef.current.getElementValue(
        `${connectorData[connectorIndex].name}-${connectorIndex}`
      );
      setConnectorData(clone);
      handleCloseModal();
    }
  };
  // helper function
  const createFormObj = (formData) => {
    const obj = {};

    formData.forEach((el) => {
      obj[el.name] = el.value;
    });

    return obj;
  };
  return (
    <React.Fragment>
      <Box
        sx={{
          backgroundColor: "var(--container-light)",
          mb: "12px",
          borderRadius: "8px"
        }}
      >
        <Box
          sx={{
            p: "12px 16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          <Typography sx={{ fontWeight: "500" }}>
            {connectorData[connectorIndex].title ||
              connectorData[connectorIndex].name + "-" + (connectorIndex + 1)}
            <EInfoToolTip
              msg={
                <ul className="tooltip-list">
                  <li>
                    <FormattedMessage id="connector.info" />
                  </li>
                </ul>
              }
            />
          </Typography>
          <IconButton aria-describedby={id} onClick={handleClick}>
            <MoreVertIcon color="primary" />
          </IconButton>
          <Popover
            elevation={0}
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
          >
            <Box
              sx={{
                width: "280px",
                borderRadius: "8px",
                backgroundColor: "var(--container-light)",
                p: 3
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 2
                }}
              >
                <Typography>
                  {/* <FormattedMessage id="exportAs" />:{" "} */}
                </Typography>
                <BaseButton
                  variant="filled"
                  sx={{ p: "5px 0", minWidth: "auto" }}
                  onClick={handleClose}
                >
                  <MoreVertIcon color="primary" />
                </BaseButton>
              </Box>
              <Box>
                <BaseButton
                  variant="filled"
                  sx={{
                    border: "2px solid #e8ebef",
                    borderRadius: "6px",
                    width: "100%"
                  }}
                  onClick={() => {
                    handleOpenModal("rename");
                    handleClose();
                  }}
                >
                  <FormattedMessage id="renameCredential" />
                </BaseButton>
                <BaseButton
                  variant="filled"
                  sx={{
                    border: "2px solid #e8ebef",
                    borderRadius: "6px",
                    width: "100%"
                  }}
                  onClick={() => {
                    handleOpenModal("remove");
                    handleClose();
                  }}
                >
                  <FormattedMessage id="deleteCredential" />
                </BaseButton>
              </Box>
            </Box>
          </Popover>
        </Box>
        <Divider />
        <Box sx={{ p: "20px 16px 28px 16px" }}>
          <EformBuilder formElements={formElementsClone} ref={childRef} />
          <Box
            sx={{
              mt: "36px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between"
            }}
          >
            <BaseButton
              variant="filled"
              sx={{
                p: "11px 53px"
              }}
              disabled={isLoading}
              onClick={handleSaveKpi}
            >
              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}
                >
                  <CircularProgress
                    style={{
                      position: "absolute",
                      left: "15px"
                    }}
                    size="1.5rem"
                  />
                  <FormattedMessage id="saving" />
                </div>
              ) : (
                <FormattedMessage id="save" />
              )}
            </BaseButton>

            <BaseButton
              variant="text"
              sx={{ opacity: "0.5", color: "var(--error) !important" }}
              onClick={() => {
                handleOpenModal("remove");
              }}
            >
              <FormattedMessage id="removeKpi" />
            </BaseButton>
          </Box>
        </Box>
      </Box>

      {/* CONNECTORS MODAL */}
      <Modal
        open={openModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            ...modalStyle,
            top: 0,
            maxWidth: "705px",
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
            p: 0,
            transform: "translate(-50%, 0)"
          }}
        >
          <Box
            sx={{
              textAlign: "right",
              p: "16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            {modalType === "remove" && (
              <Typography
                sx={{
                  color: "primary.main",
                  fontWeight: "500",
                  fontSize: "20px"
                }}
              >
                <FormattedMessage id="deleteModalTitle" />
              </Typography>
            )}

            {modalType === "rename" && (
              <Typography
                sx={{
                  color: "primary.main",
                  fontWeight: "500",
                  fontSize: "20px"
                }}
              >
                <FormattedMessage id="credentialName" />
              </Typography>
            )}

            <IconButton aria-label="close modal" onClick={handleCloseModal}>
              <CloseIcon
                alt="close icon"
                style={{ color: "var(text-primary)" }}
              />
            </IconButton>
          </Box>
          <Divider />
          <Box sx={{ p: "20px" }}>
            {modalType === "remove" && (
              <React.Fragment>
                <Typography sx={{ fontSize: "20px" }}>
                  <FormattedMessage id="doYouWantToDelete" />
                </Typography>
                <Typography
                  sx={{ fontSize: "20px", fontWeight: "500", mt: "20px" }}
                >
                  {connectorData[connectorIndex].title}
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mt: "30px"
                  }}
                >
                  <BaseButton
                    variant="text"
                    sx={{ opacity: "0.5" }}
                    onClick={() => {
                      handleCloseModal();
                    }}
                  >
                    <FormattedMessage id="cancel" />
                  </BaseButton>

                  <BaseButton
                    variant="filled"
                    sx={{
                      p: "11px 44px",
                      width: "219px"
                    }}
                    disabled={isDeleting}
                    onClick={(e) => {
                      removeKpi(e);
                    }}
                  >
                    {isDeleting ? (
                      <div
                        style={{
                          width: "100%"
                        }}
                      >
                        <CircularProgress
                          style={{
                            position: "absolute",
                            left: "15px"
                          }}
                          size="1.5rem"
                        />
                        <FormattedMessage id="deleting" />
                      </div>
                    ) : (
                      <FormattedMessage id="deleteCreds" />
                    )}
                  </BaseButton>
                </Box>
              </React.Fragment>
            )}

            {modalType === "rename" && (
              <React.Fragment>
                <EformBuilder
                  formElements={[
                    {
                      name: `${connectorData[connectorIndex].name}-${connectorIndex}`,
                      type: "text",
                      size: "widget-col-12",
                      required: false,
                      value:
                        connectorData[connectorIndex].title ||
                        `${connectorData[connectorIndex].name}-${
                          connectorIndex + 1
                        }`,
                      disabled: false
                    }
                  ]}
                  ref={kpiNameRef}
                />

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mt: "30px"
                  }}
                >
                  <BaseButton
                    variant="text"
                    sx={{ opacity: "0.5" }}
                    onClick={() => {
                      handleCloseModal();
                    }}
                  >
                    <FormattedMessage id="cancel" />
                  </BaseButton>

                  <BaseButton
                    variant="filled"
                    sx={{
                      p: "11px 44px"
                    }}
                    onClick={handleUpdateName}
                  >
                    <FormattedMessage id="save" />
                  </BaseButton>
                </Box>
              </React.Fragment>
            )}
          </Box>
        </Box>
      </Modal>
    </React.Fragment>
  );
}
